<template>
    <!-- UApp is mandatory: toasts, tooltips and programmatic overlays do not work
         without it, and it renders the toaster itself — there is no <Toast> to mount. -->
    <UApp :locale="uiLocale" :toaster="{ position: 'top-right' }">
        <!-- The layout renders the page itself: `templates/shell/` Default.vue and Blank.vue
             each carry their own `<router-view />` and take no slot. -->
        <component :is="layout" />

        <div
            v-if="appStore.isLoaderActive()"
            class="fixed inset-0 z-50 flex items-center justify-center bg-inverted/20"
        >
            <UIcon name="i-lucide-loader-circle" class="size-10 animate-spin text-primary" />
        </div>
    </UApp>
</template>

<script lang="ts" setup>
    import * as locales from '@nuxt/ui/locale'
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRoute } from 'vue-router'

    import Blank   from '@/layouts/Blank.vue'
    import Default from '@/layouts/Default.vue'
    import { useAppStore } from '@/stores/app'

    const route      = useRoute()
    const appStore   = useAppStore()
    const { locale } = useI18n()

    // Keeps Nuxt UI's built-in component texts ("no data", the table's empty row) in
    // sync with the vue-i18n locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
